<template>
  <div class="material">
    <div class="content">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="名称"> </el-table-column>
        <el-table-column prop="qualityTestingAccount" label="缩略图">
        </el-table-column>
        <el-table-column prop="snCode" label="地址">
          <template slot-scope="{ row }">
            {{ aes_decrypt(row.snCode) }}
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="试听试看"> </el-table-column>
        <el-table-column prop="qualityTestingStatus" label="时长">
        </el-table-column>
        <el-table-column label="操作" fixed="right" min-width="120">
          <template slot-scope="scope">
            <el-popconfirm
              title="是否删除该设备？"
              popper-class="customerdel-popover"
              @confirm="deleteFn(scope.row.id)"
            >
              <el-button class="textOrange-btn" slot="reference"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination
        v-show="total > queryParams.pageSize"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="init"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      tableData: [],
      total: 0,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //获取设备列表
    async init() {
      //   const res = await getDeviceList(this.queryParams);
      //   this.tableData = res.result.records;
      //   this.total = res.result.total;
    },
    // 删除
    async deleteFn() {
      //   await deleteDevice({ id });
      //   this.$message.success("删除成功");
      //   this.init();
    },
  },
};
</script>
<style lang="scss" scoped>
.material {
}
</style>
